import { ReactNode, useEffect, useEffectEvent, useState } from "react";
import { createPortal } from "react-dom";

export type PortalProps = {
  children: ReactNode;
};

export default function Portal({ children }: PortalProps) {
  const [isReady, setIsReady] = useState<boolean>(false);

  const updateIsReady = useEffectEvent((newIsReady: boolean) => {
    setIsReady(newIsReady);
  });

  useEffect(() => {
    updateIsReady(true);
  }, []);

  return isReady ? createPortal(children, document.body) : null;
}
